export const apiPath = {
  activeSubscriptions: "active_subscriptions",
  config: "config",
  contact: "contacts",
  driver: "drivers",
  driverOperations: "driver_operations",
  history: "history",
  item: "items",
  notification: "notifications",
  orderCheckoutSession: "order_checkout_sessions",
  order: "orders",
  orderFees: "order_fees",
  packlist: "packlists",
  passwordReset: "password_resets",
  paymentRequirement: "payment_requirements",
  pendingOrder: "pending_orders",
  priceMigration: "price_migrations",
  referral: "referrals",
  rewards: "rewards",
  scan: "scans",
  serviceArea: "service_areas",
  setupIntent: "setup_intents",
  subscription: "subscriptions",
  subscriptionCheckoutSession: "subscription_checkout_sessions",
  subscriptionType: "subscription_types",
  trip: "trips",
  userDeletionRequest: "user_deletion_requests",
  user: "users",
  warehouseOperations: "warehouse_operations",
};

export const notificationEndpoint = {
  allUsers: "all",
};

export const driverOperationsEndpoint = {
  completeDelivery: "complete_delivery",
  schedule: "schedule",
  startDelivery: "start_delivery",
  startPickup: "start_pickup",
  uploadProofPhoto: "upload_proof_photo",
};

export const orderHistoryEndpoint = {
  addedToCalendar: "added_to_calendar",
};

export const orderStatusEndpoint = {
  computeStatus: "compute_status",
};

export const passwordResetEndpoint = {
  requestLink: "request_link",
};

export const paymentEndpoint = {
  forPickupOnly: "pickups_only",
};

export const scanItemEndpoint = {
  destination: "destination",
  rack: "rack",
  stage: "stage",
  vehicle: "vehicle",
};

export const scanOrderEndpoint = {
  stage: "stage",
  vehicle: "vehicle",
};

export const tripEndpoint = {
  paymentRequirement: "payment_requirement",
};

export const warehouseOperationsEndpoint = {
  completeDropToWarehouse: "complete_drop_to_warehouse",
  completeMoveToVehicle: "complete_move_to_vehicle",
  completeOnboarding: "complete_onboarding",
  completeStaging: "complete_staging",
};
